import { t } from 'i18next'
import i18n from '../config/i18n'

export const getComparedText = (compared?: number | string) => {
    if (!compared) {
        return ``
    }
    if (+compared > 50) {
        return `${i18n.t('txt_higher_than')} ${compared}% ${i18n.t(
            'txt_of_trader'
        )}`
    }

    if (+compared > 25 && +compared < 50) {
        return `${i18n.t('txt_higher_than')} ${+compared * 2}% ${t(
            'txt_of_bronze'
        )}`
    } else {
        return ``
    }
}

export const getComparedTextOverall = (
    userRank: number | null | undefined,
    total: number | undefined
) => {
    //if userRanks is bronze >>
    if (!userRank || !total) {
        return ``
    }
    const comparedValue = (((total - userRank + 1) * 100) / total).toFixed(2)

    if (+comparedValue > 25) {
        return `${i18n.t('txt_higher_than')} ${comparedValue}% ${i18n.t(
            'txt_of_users'
        )}`
    }

    if (+comparedValue > 12.5 && +comparedValue < 25) {
        return `${i18n.t('txt_higher_than')}${+comparedValue * 4}% ${t(
            'txt_of_bronze'
        )}`
    } else {
        return ``
    }
}
